<template>
      <!-- ======= Services SectionOne =======  :pagination="{clickable: true}"-->
  <section id="services" class="services" data-aos="fade-up">
    <div class="container sectioncontrol" data-aos="fade-up">
      <div class="row">
        <div class="col-lg-6">
          <!-- Left card container-->
          <div class="container-fluid">
            <!-- Left row-->
            <div class="row row-cols-1 row-cols-lg-1 g-4" >
              <!-- using a v-for loop to populate cards-->
              <div class="col">
                <div class="card h-100 servicescards">
                  <a href="#" class="cardref">
                  <div class="card-body" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="600">
                    <img :src="newsphoto" class="card-img-top newsphotoimage" alt="" data-aos="fade-up" data-aos-duration="300" data-aos-delay="500">
                  </div>
                  </a>
                </div>
              </div>
              <!-- Left row ends here-->
            </div>
          </div>
        </div>
        <!-- News section starts here-->
        <div class="col-lg-6">
          <!-- Left card container-->
          <div class="container-fluid">
            <!-- Left row-->
            <div class="row row-cols-1 row-cols-lg-1 " >
              <div class="col">
                <!-- News header card-->
                <div class="card newscard">
                  <div class="card-body" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="600">
                    <div class="card-header newscardheader" data-aos="fade-up">Mining News</div>
                    
                    <div class="card newscards" v-for="(news, index) in homepagenews" :key="index" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="700" :id="index%2 > 0 ? 'oddnewsbg' : 'evennewsbg'">
                      <a :href="news.hpnewspathfile" class="newslearnmore"><div class="card-body" data-aos="fade-up">
                        <h5 class="card-title">{{ news.hpnewslinkdesc }}</h5>
                        <p class="card-text" v-html="news.hpnewsdesc" data-aos="fade-up"></p>
                      </div></a>
                     
                    </div>
                    <!-- <p class="card-text"></p> -->
                  </div>
                </div>
                <!-- News section ends here-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section><!-- End of SectionOne -->
</template>

<script>

export default{
    props: ['homepagenews', 'newsphoto']
}
</script>

<style scoped>
.newscardheader {
  background-image: url("../assets/slide-5.jpg");
  color: white;
  font-size: 24px;
}

.card-header {
  background-color: white;
  color: #003;
  font-weight: bold;
  text-align: center;
}
.servicescards {
  background-image: url("../assets/slide-5.jpg");
  color: white;
}

.valuecards {
  margin-right: 20px; 
  border-radius: 5px; 
  width: 150px;
}
#oddnewsbg {
  background-color:  #ebf5fb ;
  color: #003;
  font-weight: bold;
}

#evennewsbg {
  color: orange;
  font-weight: bold;
}
.fa-readme {
  font-size: 30px;
  padding-top: 40px;
  padding-left: 10px;
}
.newslearnmore {
  text-decoration: none;
  float: right;
  font-size: 18px;
  padding-right: 50px;
  color: #003;
}
.newscards {
  margin-top: 10px;
}
.newsphotoimage{
  width: 100%;
  height: 400px;
}
.newscardheader {
  color: white;
}

@media (min-width: 300px) and (max-width: 550px) {
.newsphotoimage{
  width: 100%;
}
.servicescards {
  width: 100%;
  padding-left: 30px;
}
}
@media (min-width: 320px) and (max-width: 575.99px) {
.col {
  width: 100%;
  height: auto;
  margin-bottom: 30px;
  background-image: none;
}
.newsphotoimage{
  width: 100%;
}
.newslearnmore{
  width: 100%;
  text-align: justify;
}
 }
 /*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */
 @media only screen and (max-width: 600px) {
  .newsphotoimage{
    height: 280px;
    margin-bottom: 0px;
   }
   .newscard {
    height: auto;
   }
   .col {
    width: 90%;
   } 
   .card-text{
    font-size: 14px;
    font-weight: bold;
    text-align: left;
    width: 100%;
   }
 }

 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {

 }
 
 /* Medium devices (landscape tablets, 768px and up) */
 @media only screen and (min-width: 768px) {

 }
 
 /* Large devices (laptops/desktops, 992px and up) */
 @media only screen and (min-width: 992px) {

 }
 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1200px) {
    
 } 
 /*@media (min-width: 280px) and (max-width: 600px) {
 .newsphotoimage{
  height: 100%;
  margin-bottom: 0px;
 }
 .newscard {
  height: auto;
 }
 .col {
  width: 100%;
 }  
}*/
</style>